<template>
	<section v-loading="loadingDM">
		<div class="row">
			<div class="col col-md-4">
				<img :src="value.thumb_img" class="img-fluid product-thumb-img" />
			</div>
			<div class="col col-md-8">
				<info-table
					ref="baseInfoTable"
					data-model-name="Product_color"
					:record-id="recordId"
					:fields="infoFields"
					:auto-load="false"
				></info-table>
			</div>
		</div>
		<curd-table
			ref="listTable"
			data-model="Order_item"
			:fields="orderTableFields"
			:has-delete="false"
			:list-url="'inventory/list_order_item/'+recordId"
		>
			<template slot="listOp" slot-scope="scope">
				<el-button size="mini" type="text" @click="goOrderInfo(scope.row.order._id)">详情</el-button>
				
							
			</template>
		</curd-table>
		<curd-table
			ref="listTable"
			data-model="Item"
			:fields="viewFields"
			:expandFields="beExpandFields"
			:has-delete="false"
			:list-url="'inventory/list_all_stocks/'+recordId"
		>
			<template slot="listOp" slot-scope="scope">
				<el-button size="mini" type="text" @click="goOrderInfo(scope.row._id)">详情</el-button>
				<el-button
					size="mini"
					type="text"
					@click="handleEdit(scope.row._id)"
					v-if="userPrivilegeMapping[62]"
				>编辑</el-button>
				
			</template>
			<template slot="customColumns" slot-scope="scope">
				<div class="text-right">
					<div v-for="(amount,warehouseId) in scope.row.amount_warehouse" :key="warehouseId">
						{{warehousesMapping[warehouseId].name}}:
						<span class="text-semi font-black">{{amount}}</span>
					</div>
				</div>
			</template>
		</curd-table>
		<editor
			:show.sync="editorVisible"
			data-model-name="Item"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import LoadDM from "@/mixins/LoadDM.js";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	mixins: [LoadDM, CurdPage],
	data() {
		return {
			items: [],
			dataModelNames: ["Product_color", "Item", "Order_item"],
			orderTableFields: [
				{ name: "order", width: "300px" },
				{ name: "created_at" },
				{
					name: "brand_show_id",
				},
				{
					name: "model",
				},
				{
					name: "amount",
				},
				{
					name: "status",
				},
				{
					name: "type",
				},
			],
			beExpandFields: [
				{
					name: "brand_show_id",
					sortable: "custom",
				},
				{
					name: "classify",
					sortable: "custom",
				},
				{
					name: "price_0",
					sortable: "custom",
				},
				{
					name: "price_1",
					sortable: "custom",
				},
				{
					name: "price_2",
					sortable: "custom",
				},
				{
					name: "price_3",
					sortable: "custom",
				},
				{
					name: "price_4",
					sortable: "custom",
				},
				// {
				// 	name: "price_5",
				// 	sortable: "custom",
				// },
				{
					name: "_id",
				},
			],
			editorFields:[
				{
					name: "amount",
					col: 6,
					rules: ["required"],
				},
				{
					name: "amount_pre",
					col: 6,
				},
				{
					name: "amount_temporary",
					col: 6,
				},
				{
					name: "amount_warehouse",
					show_name: "分仓库存",
				},
			],
			viewFields: [
				{
					name: "model",
					sortable: "custom",
				},
				{
					name: "amount",
					sortable: "custom",
				},
				{
					name: "amount_pre",
					sortable: "custom",
				},
				{
					name: "amount_temporary",
					sortable: "custom",
				},
				{
					name: "amount_stock",
					show_name: "分仓库存",
					render: info => {
						const ret = [];
						for (let warehouseId in info.amount_warehouse) {
							const amount = info.amount_warehouse[warehouseId];
							ret.push(
								`${this.warehousesMapping[warehouseId].name}:<span class="text-semi font-black">${amount}</span>`,
							);
						}
						return ret.join("<br/>");
					},
					sortable: false,
				},
			],
			infoFields: [
				[
					{
						name: "name",
						rules: ["required"],
						col: 6,
						width: "100%",
					},

					{
						name: "classify",
						rules: ["required"],
						col: 3,
					},
					{
						name: "season",
						col: 3,
						width: "100%",
					},
				],
				[
					{
						name: "brand",
						rules: ["required"],
						col: 3,
					},
					{
						name: "brand_show_id",
						col: 3,
						width: "100%",
					},
					{
						name: "color_code",
						col: 3,
						width: "100%",
					},
					{
						name: "color_name",
						col: 3,
						width: "100%",
					},
				],
			],
		};
	},
	props: {
		recordId: {
			type: String,
			default: "",
		},
		value: {
			type: Object,
			default: null,
		},
	},
	computed: {
		...mapState(["warehousesMapping", "userPrivilegeMapping"]),
		viewModels() {
			let models = {};
			for (let k in this.viewFields) {
				let val = this.viewFields[k];
				if (!val.table) {
					val.table = this.dataModel;
				}
				if (this.dataModels[val.table]) {
					models[val.name] = this.dataModels[val.table][val.name];
				}
			}

			return models;
		},
		p_c_mapping() {
			let mappings = {};
			this.product_colors.forEach((val, index) => {
				mappings[val._id] = index;
			});
			return mappings;
		},
	},
	methods: {
		goOrderInfo(id) {
			const { href } = this.$router.resolve({
				name: "Order-Info",
				params: {
					id: id,
					tab: "info",
				},
			});
			window.open(href, "_blank");
		},
		refreshData() {
			this.loadings.main = true;
			const url = "inventory/list_all_stocks/" + this.recordId;
			this.$axios
				.post(url, {
					page: this.hasPage ? this.paginations.main.pageNow : -999,
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					searchFilter: this.searchFilter,
					dateFilter: this.dateFilter,
					kvFilter: this.kvFilter,
				})
				.then(json => {
					this.loadings.main = false;

					this.items = json.data.datas;

					this.setPageTotal(json.data.pages.total);
					this.hasGetData = true;
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
	},
	mounted() {
		this.$refs["baseInfoTable"].setData(this.value);
	},
	watch: {
		value(val) {
			if (!val) {
				return;
			}
			this.$refs["baseInfoTable"].setData(this.value);
		},
	},
};
</script>
<style lang="scss" scoped>
.expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.cell {
	.el-button {
		margin-bottom: 1em;
	}
}
</style>
